var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 80,
    viewBox: "0 0 43 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 22,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 40,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 58,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 76,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 4,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 40,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 76,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 4,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 22,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 58,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 76,
    r: 4,
    fill: "#318BEC",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21);
export default __webpack_public_path__ + "static/media/Group21.7ea123170bf7178bfb4de4a3bac90043.svg";
export { ForwardRef as ReactComponent };